import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../apis";
import { API } from "../../apis/config";
import LoadingScreen from "../../components/LoadingScreen";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Experience } from "../../interfaces/ExperienceProduct";
import { ModalInfo } from "../../interfaces/ModalInfo";
import { RootState } from "../../stores";
import { set } from "../../stores/slices/experienceSlice";
import {
  changeHeaderFilter,
  convertFilterIcon,
} from "../../utils/headerFilter";
import { matchesProductNameSearch } from "../../utils/koreanSearch";
import ProductModal from "./ExperienceModal";
import SearchProductInput from "../../components/SearchProductInput";
// import map from "../../assets/images/festa_experience_map.png";

function SearchExperience() {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [modal, setModal] = useState<ModalInfo<Experience>>({
    isOpen: false,
    selected: undefined,
  });
  const dispatch = useDispatch();
  const searchRows = useSelector(
    (state: RootState) => state.experience.searchRows
  );
  const [sortedData, setSortedData] = useState<Experience[]>([]);
  const [headerFilter] = useState<{ [key: string]: number }>({});
  const productSliceData = useSelector(
    (state: RootState) => state.experience.searchRows
  );

  const Header = {
    Name: "name",
    Location: "location",
    Note: "note",
  } as const;

  const openModal = (row: Experience) => {
    if (modal) {
      setModal({ selected: row, isOpen: true });
    }
  };

  const clickHeader = (
    key: string,
    compareFn: (a: Experience, b: Experience) => number
  ) => {
    changeHeaderFilter(headerFilter, setSortedData, key, compareFn, searchRows);
  };

  const createFilterIcon = (key: string): string => {
    return convertFilterIcon(headerFilter, key);
  };

  useEffect(() => {
    const data = async () => {
      await getData<Experience[]>(API.EXPERIENCE.PRODUCTS)
        .then((res) => {
          dispatch(set(res.result.filter((value) => value.searchable)));
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    data();
  }, [dispatch]);

  useEffect(() => {
    if (sortedData.length === 0) {
      setSortedData(productSliceData);
    }
  }, [dispatch, productSliceData, sortedData.length]);

  return (
    <div>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div className="md:mx-20">
          <ScrollToTopButton />

          <ProductModal
            modal={modal}
            setModal={(isOpen, selected) => {
              setModal({ isOpen, selected });
            }}
          />

          <div className="flex items-center mt-6">
            <span className="text-2xl font-bold">체험관 검색</span>
          </div>

          {/* <div className="flex items-center justify-center mt-3">
            <img
              src={map}
              alt="map"
              className="rounded-lg w-full md:max-w-3xl"
            />
          </div> */}

          <SearchProductInput
            searchKeyword={searchKeyword}
            setSearchKeyword={setSearchKeyword}
          />
          <span className="text-sm">
            {/* 상품을 선택하여 추가 안내 사항을 확인하세요. */}
            테이블의 각 헤더(상품명, 위치, 저장)를
            <br className="md:hidden" />
            <span className="md:inline hidden">&nbsp;</span>
            선택하면 정렬할 수 있습니다.
          </span>
          <table className="my-4 w-full bg-white">
            <thead className="bg-gray-200">
              <tr>
                <th
                  className="w-1/3 px-4 py-2 text-center text-gray-600 cursor-pointer"
                  onClick={() => {
                    clickHeader(Header.Name, (a, b) =>
                      a.name.localeCompare(b.name, "ko")
                    );
                  }}
                >
                  상품명{createFilterIcon(Header.Name)}
                </th>
                <th
                  className="w-3/12 px-4 py-2 text-center text-gray-600 cursor-pointer"
                  onClick={() => {
                    clickHeader(Header.Location, (a, b) =>
                      a.location.localeCompare(b.location, "ko")
                    );
                  }}
                >
                  위치{createFilterIcon(Header.Location)}
                </th>
                <th
                  className="w-2/12 px-4 py-2 text-center text-gray-600 cursor-pointer"
                  onClick={() => {
                    clickHeader(Header.Note, (a, b) =>
                      a.note.localeCompare(b.note, "ko")
                    );
                  }}
                >
                  비고{createFilterIcon(Header.Note)}
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData
                .filter((item) =>
                  matchesProductNameSearch(item.name ?? "", searchKeyword)
                )
                .map((item, key) => (
                  <tr
                    className={`cursor-pointer hover:bg-gray-100 border-t ${
                      item.note ? "underline" : ""
                    }`}
                    key={key}
                  >
                    <td
                      className="px-4 py-2 text-sm md:text-base"
                      onClick={() => openModal(item)}
                    >
                      {item.name}
                    </td>
                    <td className="px-4 py-2" onClick={() => openModal(item)}>
                      {item.location}
                    </td>
                    <td
                      className="px-4 py-2 text-sm"
                      onClick={() => openModal(item)}
                    >
                      {item.note}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SearchExperience;
